export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20abstract%20film%20projector%20beam%20cutting%20through%20darkness%2C%20vintage%20movie%20theater%20aesthetic%2C%20dramatic%20chiaroscuro%2C%20rich%20dark%20textures%2C%20elegant%20film%20noir%20composition%2C%20no%20text%2C%20atmospheric%20and%20cinematic&width=1920&height=1080&seq=hero-main-2026&orientation=landscape"
          alt="51电影网 - 擦边电影未删减版完整版在线观看"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/15 border border-primary-500/25 mb-5">
              <i className="ri-fire-line text-primary-400 text-sm"></i>
              <span className="text-xs text-primary-300 whitespace-nowrap">每周更新 · 稀缺资源</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              51电影网 · 擦边电影完整版合集
            </h1>

            <p className="text-lg md:text-xl text-primary-400 font-heading mb-6">
              发现删减背后的秘密，每一帧都不该被隐藏
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              51电影网专注整理全球擦边电影未删减版、限制级片段与隐藏敏感镜头资源。从经典禁片档案到最新海外完整版，从蓝光高清修复到导演剪辑版——我们以每周更新的节奏，持续为你呈现全网最全的高清完整版在线观看合集。每一部电影都保留导演原始创作意图，让被删减的画面重见天日。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-heading text-accent-400">200+</span>
                <span className="text-xs text-foreground-500">部完整版资源</span>
              </div>
              <div className="w-px h-5 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-heading text-accent-400">每周</span>
                <span className="text-xs text-foreground-500">稳定更新</span>
              </div>
              <div className="w-px h-5 bg-background-300"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-heading text-accent-400">蓝光</span>
                <span className="text-xs text-foreground-500">高清画质</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line"></i>
                浏览专题合集
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 hover:border-primary-400 text-foreground-600 hover:text-primary-400 rounded-md text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bar-chart-line"></i>
                查看热度榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative rounded-lg overflow-hidden border border-background-300/50">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20film%20poster%20collage%20with%20multiple%20movie%20frames%20overlapping%2C%20deep%20crimson%20and%20black%20color%20palette%2C%20dramatic%20chiaroscuro%20lighting%2C%20film%20noir%20aesthetic%2C%20mysterious%20silhouettes%2C%20vintage%20movie%20poster%20style%2C%20no%20text%2C%20atmospheric%20and%20artistic%20composition&width=900&height=1200&seq=hero-poster-2026&orientation=portrait"
                alt="51电影网擦边电影限制级片段隐藏资源合集"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/40 to-transparent pointer-events-none"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}